import cn from 'classnames';
import { useFormikContext } from 'formik';
import React, { useCallback, useMemo, useState } from 'react';
import bt from '../bootstrap.module.css';
import FormElementWrapper from '../components/FormElementWrapper';
import InlineEdit from '../components/InlineEdit';
import ObligationSource from '../components/ObligationSource';
import useGetFormGeneratorItemError from '../hooks/useGetFormGeneratorItemError';

const Select = props => {
  const { data, onChange, disabled, isBuilder, value, readOnly } = props;
  const { requiredError } = useGetFormGeneratorItemError(data.id);
  const [isEditing, setIsEditing] = useState(false);
  const { setFieldValue, values } = useFormikContext();
  const index = values?.data?.findIndex(({ id }) => id === props.data.id);

  const handleChange = useCallback(
    e => {
      onChange(data.type, data.id, e.target.value);
    },
    [onChange, data.type, data.id],
  );

  const handleLabelChange = e => {
    const { name, value } = e.target;
    setFieldValue(`data[${index}].${name}`, value);
  };

  const resolveOptions = useMemo(() => {
    const options = props?.data?.options || [];
    return value ? options : [{ label: 'Please select option', id: '' }, ...options];
  }, [props, value]);
  return (
    <FormElementWrapper {...props} onClick={!readOnly ? () => setIsEditing(true) : undefined}>
      <div className={bt['form-group']}>
        <div className="font-semibold">
          <InlineEdit
            value={data.label}
            onChange={handleLabelChange}
            fieldName="label"
            isEditing={isEditing}
            onSetIsEditing={setIsEditing}
            readOnly={readOnly}
          />
        </div>
        {data.compliance && <ObligationSource source={data.obligationSource} />}

        <select
          className={cn('block w-full border-b h-8', {
            'text-gray-500': !value,
            'cursor-pointer': !disabled,
          })}
          onChange={handleChange}
          disabled={disabled || isBuilder}
          value={value}
        >
          {resolveOptions.map(option => {
            const this_key = option.id;
            return (
              <option value={this_key} key={this_key}>
                {option.label}
              </option>
            );
          })}
        </select>
        {requiredError && <div style={{ color: 'red', marginTop: 4 }}>This field is required</div>}
      </div>
    </FormElementWrapper>
  );
};

export default Select;
